import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { SvgIconEl } from "common/components/svg-icon";
import { hasSlot } from "common/util/dom";
import { ButtonTheme } from "../button/constants";
const BodyTextClassName = `banner-body`;
export function template() {
  let bodyTextNode = null;
  if (hasSlot(this, `body-text`)) {
    bodyTextNode = /* @__PURE__ */ jsx("slot", {
      sel: `.${BodyTextClassName}`,
      attrs: { name: `body-text` }
    });
  } else if (this.attr(`body-text`)) {
    bodyTextNode = this.helpers.formatText(this.attr(`body-text`), { className: BodyTextClassName });
  }
  const hasCta = this.attr(`ctas`) && this.attr(`ctas`).length > 0;
  return /* @__PURE__ */ jsx("div", {
    sel: ".banner-wrapper",
    class: {
      [`${this.attr(`type`)}-type`]: true
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".banner-panel",
    class: {
      "has-cta": hasCta,
      [`${this.attr(`size`)}-size`]: true,
      [`${this.attr(`theme`)}-theme`]: true,
      [`${this.attr(`type`)}-type`]: true,
      "body-only": Boolean(bodyTextNode) && !this.attr(`header-text`)
    }
  }, this.helpers.getIcon() ? /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".banner-title-icon",
    attrs: {
      icon: this.helpers.getIcon()
    },
    class: { "banner-copy-no-header": !this.attr(`header-text`) }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".banner-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".banner-copy",
    class: { "banner-copy-no-header": !this.attr(`header-text`) }
  }, this.attr(`header-text`) ? /* @__PURE__ */ jsx("header", {
    sel: ".banner-header"
  }, this.attr(`header-text`)) : null, bodyTextNode), hasCta ? /* @__PURE__ */ jsx("div", {
    sel: ".banner-actions"
  }, this.attr(`ctas`).map((cta) => {
    const isEmbedded = this.attr(`type`) === this.helpers.BannerType.Embedded;
    const isSmall = this.attr(`size`) === this.helpers.BannerSize.Small;
    const embeddedTheme = isSmall ? ButtonTheme.Tertiary : ButtonTheme.Secondary;
    const shownTheme = isEmbedded ? embeddedTheme : cta.theme || embeddedTheme;
    const shouldShowXIcon = isSmall && cta.actionName === this.helpers.BannerAction.Dismiss;
    return /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".cta-button",
      attrs: {
        theme: shownTheme,
        icon: shouldShowXIcon ? `x` : cta.icon,
        type: this.helpers.getButtonType()
      },
      class: {
        "banner-action-button-embedded": isEmbedded,
        [`${this.attr(`theme`)}-theme`]: true
      },
      on: { click: () => this.helpers.handleCtaButtonClick(cta) }
    }, !shouldShowXIcon ? cta.text : null);
  })) : null)));
}
